export class CustomError extends Error {
  constructor(message, internal) {
    super(message); // (1)
    this.name = 'CustomError'; // (2)
    this.internal = internal;
  }
}
